module.exports = __webpack_public_path__ + "assets/img/186101.ebb02982.svg";